export const TranslationsRO = {
    // languages
    languages: {
        en: 'English',
        ar: 'عربى',
        bg: 'Bulgaria',
        da: 'Dansk',
        de: 'Deutsch',
        es: 'Español',
        fi: 'Suomi',
        fr: 'Français',
        el: 'Ελληνικά',
        it: 'Italiano',
        id: 'Bahasa Indonesia',
        ja: '日本語',
        km: 'ភាសាខ្មែរ',
        nb: 'Bokmål',
        pt: 'Português',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'Svenska',
        sr: 'Srpski',
        th: 'ภาษาไทย',
        vi: 'Tiếng Việt',
        zh: '中文',
        hi: 'हिन्दी',
        ko: '한국어',
        ru: 'Русский',
        tr: 'Türkçe',
        nl: 'Nederlands',
        pl: 'Polski',
        ms: 'Bahasa Melayu',
        ro: 'Română',
        cs: 'Čeština',
        hu: 'Magyar',
        ta: 'தமிழ்',
        te: 'తెలుగు',
        bn: 'বাংলা',
    },
    codes: {
        en: 'EN',
        bg: 'BG',
        ar: 'AR',
        da: 'DA',
        de: 'DE',
        es: 'ES',
        fi: 'FI',
        fr: 'FR',
        el: 'EL',
        it: 'IT',
        id: 'ID',
        ja: 'JA',
        km: 'KM',
        nb: 'NB',
        pt: 'PT',
        pa: 'PA',
        sv: 'SV',
        sr: 'SR',
        th: 'TH',
        vi: 'VI',
        zh: 'ZH',
        hi: 'HI',
        ko: 'KO',
        ru: 'RU',
        tr: 'TR',
        nl: 'NL',
        pl: 'PL',
        ms: 'MS',
        ro: 'RO',
        cs: 'CS',
        hu: 'HU',
        ta: 'TA',
        te: 'TE',
        bn: 'BN',
    },
    short_names: {
        en: 'ENG',
        ar: 'عربى',
        bg: 'BGR',
        da: 'DAN',
        de: 'DEU',
        es: 'ESP',
        fi: 'FIN',
        fr: 'FRA',
        el: 'ELL',
        it: 'ITA',
        id: 'IND',
        ja: '日本語',
        km: 'KHM',
        nb: 'NOB',
        pt: 'POR',
        pa: 'ਪੰਜਾਬੀ',
        sv: 'SVE',
        sr: 'SRP',
        th: 'THA',
        vi: 'VIE',
        zh: '中文',
        hi: 'HIN',
        ko: 'KOR',
        ru: 'RUS',
        tr: 'TUR',
        nl: 'NLD',
        pl: 'POL',
        ms: 'MSA',
        ro: 'RON',
        cs: 'CES',
        hu: 'HUN',
        ta: 'TAM',
        te: 'TEL',
        bn: 'BEN',
    },
    // BASE
    phrases: {
        order_online: 'Comanda online',
        cart: 'Cart',
        open_24: '24 de ore',
        closed: 'Închis',
        free: 'GRATUIT',
        something_went_wrong: 'ceva a mers prost',
        try_again: 'încearcă din nou',
    },
    constants: {
        calendar: {
            days: {
                monday: 'luni',
                tuesday: 'marţi',
                wednesday: 'miercuri',
                thursday: 'joi',
                friday: 'vineri',
                saturday: 'sâmbătă',
                sunday: 'duminică',
            },
        },
        services: {
            pickup: 'Ridicare',
            delivery: 'Livrare',
            dine_in: 'Dine-In',
            table_booking: 'Rezervarea mesei',
        },
        payment: {
            method: {
                cash: 'Contant',
                card: 'Kartă',
                stripe: 'Credit Card',
                paypal: 'PayPal',
                cardconnect: 'Credit Card',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                razor_pay: 'Razor Pay',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                custom: 'Custom',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                authorized: 'Authorize.net'
            },
            // BACKENDMETHODNAMES
            backend_method: {
                cash: 'Contant',
                card: 'Kartă',
                stripe: 'Stripe',
                paypal: 'PayPal',
                cardconnect: 'CardConnect',
                paygate_payweb: 'PayGate PayWeb',
                poli_pay: 'POLi Pay',
                ipay88: 'iPay88',
                bambora_apac: 'Bambora APAC',
                bambora_na: 'Worldline',
                pesapal: 'Pesapal',
                ath_movil: 'ATH Móvil',
                checkout: 'Checkout',
                checkout_apple_pay: 'Apple Pay (Checkout.com)',
                checkout_google_pay: 'Google Pay (Checkout.com)',
                stripe_digital_wallet: 'Google/Apple Pay',
                razor_pay: 'Razor Pay',
                gravity: 'Gravity',
                authorized: 'Authorize.net',
                elavon: 'Elavon',
                red_dot: 'Red Dot Payment',
                gkash: 'Gkash',
                custom: 'Custom',
                sgepay: 'SGEPAY',
                payway: 'ABA Pay',
                bancontact: 'Bancontact',
                swish: 'Swish',
                fiserv: 'Fiserv',
                viva_wallet: 'Viva Wallet',
                cabbagepay: 'CabbagePay',
                paymongo: 'PayMongo',
                nuvei: 'Nuvei',
                ONLINE: 'Online',
                online: 'Online'
            },
            status: {
                success: 'Succes',
                pending: 'În așteptare',
                error: 'Eroare',
                refunded: 'Rambursat',
                refunding: 'Rambursare',
                partial_refunded: 'Rambursat parțial',
            },
        },
    },
    components: {
        field: {
            dropzone: {
                remove: 'Elimina',
                drop_here: 'Aruncați fișierele aici sau faceți clic pentru a selecta unul',
                accepts: 'Acceptă {{fileTypes}} fișiere',
                errors: {
                    max_files: 'Maxim de {{number}} permis',
                    max_size: 'Dimensiunea maximă a fișierului de {{kilobytes}} KB',
                },
            },
        },
    },
    // UI
    store: {
        global: {
            errors: {
                dine_in_close: 'Magazinul este în prezent închis și o comandă de dine-in imediat nu poate fi plasată. Puteți încerca să comandați pentru o dată și oră mai târziu',
            },
            buttons: {
                order: {
                    book_order: 'Rezervați masa / Comandă online',
                    order_online: 'Comanda online',
                    book_table: 'Rezervați o masă',
                    order: 'Comanda',
                    book: 'Carte',
                    cart: 'Cart',
                    restart: 'Repornire',
                    closed: 'Magazin închis',
                    not_accepting: 'Nu se acceptă comenzi',
                },
            },
        },
        modals: {
            auth: {
                login: 'Log in',
                register: 'Registru',
                register_commence: 'Continua',
                register_complete: 'Creează cont',
                register_confirmation_sent: 'Un cod de confirmare a fost trimis la adresa dvs. de e-mail. Vă rugăm să introduceți-l mai jos pentru a continua',
                register_confirmation_resent: 'Codul de confirmare a fost trimis din nou, verificați spamul sau reporniți procesul',
                register_restart: 'Repornire',
                register_resend_code: 'Retrimite codul',
                register_confirmation_code_subject: 'Cod de confirmare prin e-mail',
                register_confirmation_code_email: 'Codul dvs. de confirmare prin e-mail este {{confirmation_code}} (Expiră în 24 de ore)',
                login_placeholder: 'E-mail',
                password_placeholder: 'Parolă',
                confirm_password_placeholder: 'Confirmați parola',
                confirmation_code_placeholder: 'Cod de confirmare prin e-mail',
                accept_terms: 'Acceptați Termenii și Condițiile',
                accept_terms_view: 'Vedere',
                login_facebook: 'Conectați-vă cu Facebook',
                login_google: 'Conectați-vă cu Google',
                benefits: 'Conectați-vă sau creați un cont pentru a vă salva toate comenzile',
                logged_in: 'Conectat cu succes',
                logged_out: 'Deconectat',
                password_reset: {
                    init_button: 'Trimiteți e-mail pentru resetarea parolei',
                    init_success: 'Linkul de resetare a parolei a fost trimis pe e-mailul dvs',
                    complete_button: 'Resetează parola',
                    complete_success: 'Parola resetată cu succes, autentificați-vă cu noua parolă',
                    forgot_password_text: 'Ați uitat parola?',
                    forgot_password_link: 'Resetează parola',
                    remember_password_text: 'Îți amintești parola?',
                    remember_password_link: 'Întoarce-te',
                    invalid_title: 'Resetarea parolei este nevalidă',
                    invalid_description: 'Acest link de resetare a parolei nu este valid, solicitați unul nou',
                    invalid_link: 'Accesați Login',
                    title: 'Resetare parolă',
                    description: 'Introduceți o nouă parolă pentru contul dvs',
                },
                error_generic: 'A apărut o eroare, vă rugăm să încercați din nou sau să ne contactați',
                error_accept_terms: 'Vă rugăm să acceptați termenii și condițiile',
                error_password_length: 'Minimum 6 caractere pentru parola',
                error_social: 'A apărut o eroare, încercați din nou sau contactați-ne',
                error_confirmation_code: 'Cod de confirmare nevalid',
                error_invalid_code: 'Cod de confirmare nevalid',
                error_exists: 'Utilizatorul există deja',
                error_invalid_email_pass: 'Adresă de e-mail sau parolă nevalidă',
                error_password_no_match: 'Parolele nu se potrivesc între ele',
                error_user_not_found: 'Niciun utilizator cu acea adresă de e-mail',
                error_invalid_email: 'Adresă de e-mail nevalidă',
                error_invalid_reset_token: 'Link de resetare nevalid, solicitați altul',
            },
            booking: {
                form: {
                    name: 'Numele complet',
                    email: 'Adresa de e-mail',
                    phone: 'Număr de telefon',
                    number_of_people: 'Numărul de persoane',
                    number_of_people_max: 'Număr de persoane ({{max_people}} Max)',
                    number_of_people_min: 'Număr de persoane ({{min_people}} min.)',
                    number_of_people_max_min: 'Număr de persoane (între {{min_people}} și {{max_people}})',
                    notes: 'Note / Cereri speciale',
                    submit: 'Trimiteți cererea de rezervare',
                    email_optional: '(opțional)',
                    date: 'Dată',
                    duration: 'Durată',
                    seating: 'Ore disponibile',
                    number_of_guests: 'Număr de oaspeți',
                    notes_placeholder: 'Alergii, ocazie, preferință de loc',
                    reserving: 'Se rezervă...',
                    reserve_table: 'Rezervă o masă',
                    please_choose_a_date_and_time: 'Alegeți o dată și o oră.',
                    invalid_people: 'Numărul de persoane trebuie să fie între {{min}} și {{max}}.',
                    party_size_max_fallback: 'maximul permis',
                    loading_available_times: 'Se încarcă orele disponibile…',
                    select_a_date_to_see_available_times: 'Selectați o dată pentru a vedea orele disponibile.',
                    no_times_available_for_this_date: 'Nu există ore disponibile pentru această dată. Alegeți o altă zi.',
                    shift: 'Tură',
                    service_times: 'Program de servire',
                    new_shift: 'Tură nouă',
                    time: 'oră',
                    times: 'ore',
                    unavailable: 'Indisponibil',
                    available: 'Disponibil',
                    required_name: 'Introduceți numele.',
                    required_phone: 'Introduceți numărul de telefon.',
                    required_email: 'Introduceți adresa de e-mail.',
                    invalid_email: 'Introduceți o adresă de e-mail validă.',
                    required_terms: 'Acceptați termenii înainte de a rezerva.',
                    reservation_is_unavailable: 'Rezervarea nu este disponibilă.',
                    please_contact_the_restaurant_directly: 'Contactați restaurantul direct.',
                    almost_done: 'Aproape gata',
                    your_details: 'Datele dvs.',
                    tell_us_who_s_coming: 'Spuneți-ne cine vine ca să vă putem confirma rezervarea.',
                    book_your_table: 'Rezervați masa',
                    choose_a_time_that_works_for_you: 'Alegeți o oră care vă convine.',
                    send_your_reservation_request_and_the_restaurant_will_take_care_of_the_rest: 'Trimiteți cererea de rezervare, iar restaurantul se ocupă de rest.',
                    select_date: 'Selectați data',
                    standard: 'Standard',
                    minutes: 'minute',
                    next: 'Înainte →',
                    back: '← Înapoi',
                    accept_terms: 'Accept termenii și condițiile.',
                    info_1: 'Veți primi o notificare prin e-mail când rezervarea dvs. este acceptată sau refuzată',
                },
                errors: {
                    not_found: "Rezervarea nu există. Probabil a fost ștearsă",
                    generic: 'A apărut o eroare, reîmprospătați pagina sau contactați-ne',
                    something_went_wrong: 'Ceva a mers prost',
                    accept_terms: 'Vă rugăm să acceptați termenii și condițiile',
                    required_phone: 'Vă rugăm să introduceți numărul dvs. de telefon',
                    required_email: 'Vă rugăm să introduceți adresa dvs. de e-mail',
                    required_zip: 'Vă rugăm să introduceți codul poștal de facturare',
                    required_name: 'Vă rugăm să introduceți numele dvs',
                    invalid_email: 'Vă rugăm să introduceți o adresă de email validă',
                    invalid_phone: 'Vă rugăm să introduceți un număr de telefon valid',
                    invalid_people: 'Număr nevalid de persoane',
                    missing_custom_fields: 'Vă rugăm să completați toate câmpurile obligatorii.',
                    booking_capacity_threshold: 'Suntem complet ocupați la această oră. Încercați altă oră.',
                    slot_unavailable: 'Suntem complet ocupați pentru acest număr de persoane. Încercați altă oră.',
                    booking_date_paused: 'Rezervările sunt suspendate pentru această dată. Alegeți o altă zi.',
                    invalid_table_assignment: 'Aceste mese nu pot găzdui grupul dvs. Alegeți altă oră.',
                    exceeded_order_limit: 'Prea multe cereri de rezervare. Încercați din nou mai târziu.',
                    validation_failed_recaptcha_v3: 'Trafic neobișnuit detectat. Folosiți un VPN? Finalizați verificarea de mai sus și încercați din nou.',
                    validation_failed_recaptcha_v2: 'Rezervarea nu a putut fi inițiată. Încercați din nou sau folosiți altă metodă. Dacă folosiți un VPN, încercați mai întâi să îl dezactivați.',
                    booking_already_exists: 'Această rezervare a fost deja trimisă. Verificați e-mailul sau deschideți linkul rezervării.',
                    invalid_party_size: 'Alegeți un număr valid de persoane.',
                    invalid_request: 'Cerere nevalidă. Reîmprospătați pagina și încercați din nou.',
                    table_booking_unavailable: 'Rezervarea meselor nu este disponibilă.',
                },
            },
            cart: {
                title: 'Coș',
                proceed_to_checkout: 'Continuați către verificare',
                edit_dish: 'Edita',
                remove_dish: 'Elimina',
                no_items_1: 'Nu există articole în coș',
                no_items_2: 'Adăugați mai întâi câteva pentru a continua',
                free_delivery_notice: 'Livrare gratuită pentru comenzile de peste {{value, currency}}',
                errors: {
                    min_order_promo: 'Valoarea minimă a coșului de {{value, currency}} este necesară înainte ca această promoție să fie aplicată',
                    min_order_delivery: 'Valoarea minimă a coșului de {{value, currency}} pentru livrare',
                },
                promo: {
                    heading: 'Cod promoțional',
                    placeholder: 'Introdu codul promoțional',
                    add: 'Adăugați cod',
                    title: 'Promoție {{name}} adăugată în coș',
                    fixed_discount: '{{value, currency}} Dezactivat',
                    percent_discount: '{{value}}% reducere',
                    added_to_cart: 'Promoție adăugată în coș',
                    errors: {
                        not_found: 'Promo nu a fost găsită',
                        disabled: 'Promoția este dezactivată',
                        not_available: 'Promoția nu este disponibilă momentan',
                        not_eligible: 'Nu sunt eligibile pentru a aplica codul promoțional',
                        not_available_time: 'Promoția nu se aplică pentru această perioadă',
                        logged_in_only: 'Trebuie să fii autentificat pentru a folosi această promoție',
                        already_used: 'Ai folosit deja această promoție',
                        invalid: 'Această promoție nu mai este valabilă',
                        invalid_service: 'Această promoție nu este valabilă pentru serviciul ales de dvs',
                        later_only: 'Valabil doar pentru precomenzi',
                        now_only: 'Valabil doar pentru comenzile cu scadență imediată, nu pentru precomenzi',
                        generic: 'Hopa... ceva a mers prost și a fost înregistrat',
                        dishes_required_multi: 'Această promoție va fi aplicată numai atunci când anumite articole sunt adăugate în coș',
                        dishes_required_single: "Această promoție va fi aplicată numai pentru '{{dish}}'",
                    },
                },
                tip: {
                    title: 'Sfat de comandă',
                    placeholder: 'Adăugați un sfat de comandă',
                },
            },
            free_items_promo: {
                title: 'Articole gratuite',
                usage_confirmation: {
                    question: 'Sunteți eligibil pentru articole gratuite. Doriți să le vedeți și să le adăugați?',
                    cancellation: "Nu, nu vreau articole gratuite",
                    acceptance: 'Da',
                },
                free_items_selection: {
                    multiple: {
                        description: 'Selectați {{number}} articole gratuite',
                    },
                    single: {
                        description: 'Selectați un articol gratuit',
                    },
                    confirm_button: 'Confirma',
                },
            },
            checkout: {
                title: 'Verificare',
                subtitle: 'Confirmați detaliile comenzii dvs',
                details: {
                    service: 'Serviciu',
                    due: 'Datorită',
                    due_now_asap: 'Acum / cât mai curând posibil',
                    address: 'Adresa de livrare',
                    total: 'Total',
                    table: 'Masă',
                    store_location: 'Adresa magazinului',
                },
                customer: {
                    title: 'Client',
                    subtitle: 'Conectați-vă pentru a vă salva comanda și detaliile',
                    button: 'Log in',
                    name: 'Numele complet',
                    email: 'E-mail',
                    phone: 'Telefon',
                    phone_important: 'Telefon (Important)',
                    notes: 'Note de comandă',
                    delivery_notes: 'Instrucțiuni de livrare / Note de comandă',
                    optional: 'opțional',
                },
                payment: {
                    title: 'Modalitate de plată',
                    qr_modal_help: 'Folosiți aplicația mobilă {{app}} pentru a scanarea QR și completați plata pentru această comandă. Odată ce plata a fost completată pe aplicația mobilă, puteți închide acest modal QR. Vă rugăm să nu închideți acest modal QR dacă nu ați terminat procesul de plată.',
                    switch_to_app_help: 'Prin apăsarea butonului de mai jos, aplicația mobilă {{app}} va fi deschisă automat pentru a completa plata pentru această comandă. Odată ce plata a fost completată pe aplicația mobilă, puteți închide acest modal. Vă rugăm să nu închideți acest modal dacă nu ați terminat procesul de plată.',
                    open_app: 'Deschideți {{app}} Aplicația',
                    continue: 'Continua',
                    continue_to_payment: 'Continuați către {{method}}',
                    back_to_cart: 'Înapoi la coș',
                },
                accept_terms: 'Acceptați Termenii și Condițiile',
                accept_terms_view: 'Vedere',
                processing_order: 'Procesarea comenzii',
                warning: {
                    different_payment_currency: 'Prețurile magazinului sunt în {{store_currency}} dar metoda de plată este în {{payment_currency}}',
                    closing_soon: 'Se închide în curând, comenzile trebuie plasate în {{value}} minute',
                    closed: 'Ne pare rău, acest serviciu s-a închis și comenzile nu sunt acceptate',
                    paused: 'Ne pare rău, acest serviciu a fost întrerupt și comenzile nu sunt acceptate deocamdată',
                    expired: 'Nu vă mai putem onora comanda la ora selectată. Vă rugăm să alegeți o dată sau o oră ulterioară',
                },
                errors: {
                    walletly_promo: 'Promoția Walletly are o eroare, vă rugăm să încercați o altă promoție!',
                    stripe_generic: 'Eroare card de credit, încercați din nou sau altă metodă',
                    validation_failed: 'Această plată nu poate fi acceptată în acest moment. Vă rugăm să încercați din nou mai târziu sau să alegeți o altă metodă de plată.',
                    validation_failed_recaptcha_v3: 'Trafic neobișnuit detectat. Folosești VPN? Vă rugăm să finalizați provocarea de mai sus și să încercați din nou.',
                    validation_failed_recaptcha_v2: 'Nu am putut iniția plata. Vă rugăm să încercați din nou sau să utilizați o altă metodă. Dacă utilizați un VPN, încercați mai întâi să îl dezactivați.',
                    stripe_loading_fail: 'Eroare la încărcarea formularului de plată, încercați din nou',
                    something_went_wrong: 'Ceva a mers prost',
                    paypal_generic: 'A apărut o eroare cu PayPal, încercați din nou sau alegeți o altă metodă de plată',
                    payment_fail: 'Plata nu a reușit, încercați din nou sau selectați altă metodă de plată',
                    payment_cancelled: 'Plata a fost anulată, încercați din nou sau selectați altă metodă de plată',
                    payment_error: 'Eroare la procesarea plății online, încercați din nou sau alegeți o altă metodă de plată',
                    payment_declined: 'Metoda dvs. de plată a fost refuzată',
                    card_declined: "Your card was declined and payment couldn't be processed",
                    promo_max_uses_exceeded: "Acest cod promoțional a atins limita de utilizare și nu mai este disponibil.",
                    store_closed: 'Magazinul este inchis si nu mai accepta comenzi',
                    accept_terms: 'Vă rugăm să acceptați termenii și condițiile',
                    required_payment: 'Vă rugăm să selectați o metodă de plată',
                    required_phone: 'Vă rugăm să introduceți numărul dvs. de telefon',
                    required_email: 'Vă rugăm să introduceți adresa dvs. de e-mail',
                    required_zip: 'Vă rugăm să introduceți codul poștal de facturare',
                    required_name: 'Vă rugăm să introduceți numele dvs',
                    invalid_email: 'Vă rugăm să introduceți o adresă de email validă',
                    invalid_phone: 'Vă rugăm să introduceți un număr de telefon valid',
                    invalid_cc_number: 'Numărul cardului dvs. de credit este nevalid',
                    invalid_order_amount: 'Suma minimă necesară pentru această metodă de plată',
                    retry_cc_number: 'A apărut o eroare, reintroduceți numărul cardului dvs. de credit și încercați din nou',
                    closed: 'Magazinul este închis și nu acceptă comenzi',
                    promo_login_required: 'Trebuie să fii autentificat pentru a folosi această promoție',
                    promo_used: 'Ai folosit deja această promoție',
                    promo_by_payment_method_not_applicable: 'Promoția nu se aplică metodei de plată selectate.',
                    missing_custom_checkout_fields: 'Vă rugăm să completați toate câmpurile obligatorii.',
                    delivery_unavailable: 'Serviciul de livrare nu este disponibil în acest moment. Vă rugăm să considerați să faceți o comandă Pick Up în schimb.',
                    required_delivery_provider: 'Vă rugăm să alegeți un serviciu de livrare.',
                    required_delivery_quotation: 'Estimarea de livrare a expirat.',
                    exceeded_order_limit: 'Primim o mulțime de comenzi în acest moment. Vă rugăm să alegeți o oră ulterioară.',
                    exceeded_order_limit_later: 'Nu vă mai putem onora comanda la ora selectată. Vă rugăm să alegeți o dată sau o oră ulterioară',
                },
                button: {
                    continue: 'Continuați cu plata',
                    place_order: 'Plasați Comanda',
                    update_order: 'Actualizați comanda',
                },
                delivery_estimation: {
                    title: 'Estimare de livrare',
                    details: {
                        provider: 'Furnizor de livrare',
                        estimated_fee: 'Taxa estimata',
                        estimated_total_fee: 'Taxa de livrare totală',
                        estimated_discount_fee: 'Reducere la taxa de livrare',
                        previous_estimated_fee: 'Taxa estimată anterioară',
                        tips: 'Sfaturi',
                        estimated_delivery_time: 'Timp de livrare estimat',
                        uber_new_estimation: 'Solicitați o nouă estimare',
                        uber_new_estimation_success: 'S-a aplicat o nouă estimare de livrare Uber.',
                        uber_estimation_expired: 'Estimarea de livrare a expirat',
                        uber_price: 'Ținem prețul Uber',
                        uber_need_time: 'Am nevoie de mai mult timp',
                        lalamove_price: 'Deținem taxa de livrare Lalamove',
                        lalamove_new_estimation_success: 'S-a aplicat o nouă estimare de livrare Lalalmove.',
                        lalamove_estimation_expired: 'Estimarea de livrare a expirat',
                        lalamove_need_time: 'Am nevoie de mai mult timp',
                        lalamove_new_estimation: 'Solicitați o nouă estimare',
                    },
                    quotation_error: 'A apărut o eroare la calcularea estimării livrării.',
                },
            },
            customer: {
                age_v: {
                    title: 'Verificarea vârstei',
                    required_for_items: 'Necesar pentru a comanda anumite articole',
                    min_age: 'Vârsta minimă: {{age}} ani',
                    est_time: 'Timp estimat de verificare: {{time}} ore',
                    upload_description: 'Încărcați ID-ul dvs. mai jos pentru verificare. Veți fi notificat prin e-mail odată ce ați fost verificat. Încărcați până la 2 imagini cu o dimensiune maximă de 2 MB fiecare',
                    pending_description_1: 'Vă mulțumim pentru înregistrarea documentelor dvs. Veți fi notificat prin e-mail când ați fost aprobat',
                    pending_description_2: 'Reîmprospătați pagina pentru a actualiza starea de verificare. Timpul estimat de verificare este de {{time}} ore',
                    approved_description: 'Contul dvs. a fost verificat și puteți comanda din meniuri restricționate',
                    rejected_description: 'ID-ul dvs. a fost respins. Dacă doriți să încercați din nou, vă rugăm să reîncărcați ID-ul',
                    upload: 'Încărcați',
                    reupload: 'Reîncărcați documentele',
                    go_back: 'Întoarce-te',
                    view_document: 'Vizualizați documentul {{number}}',
                    status: {
                        unverified: 'Neverificat',
                        pending: 'În așteptarea aprobării',
                        approved: 'Verificat cu succes',
                        rejected: 'Respins',
                    },
                },
                headings: {
                    sessions: 'Sesiuni',
                    orders: 'Comanda',
                    spend: 'Petrece',
                    order_history: 'Istoricul comenzilor',
                    loyalty: 'Loialitate',
                    loyalty_points: 'Puncte de fidelitate',
                    added: 'Promoție adăugată.',
                },
                loyalty_errors: {
                    invalid_cart_items: 'Vă rugăm să alegeți orice articol înainte de a le valorifica!',
                    not_found: 'Promo nu a fost găsită!',
                    already_exists: 'Promoția există deja!',
                    try_again: 'Nu se poate aplica această ofertă. Vă rugăm să încercați din nou!',
                },
            },
            custom_payment: {
                title: '{{name}} Formular de plată',
                description: 'Ați ajuns la formularul nostru de plată online. Vă rugăm să completați câmpurile de mai jos pentru a face o plată. Dacă o sumă nu este introdusă, detaliile dvs. vor fi salvate, dar nu veți fi taxat.',
                disabled: 'Această pagină de plată online nu a fost configurată corect. Vă rugăm să contactați proprietarul site-ului pentru a rectifica problema.',
                success: 'Plata dvs. a fost procesată cu succes și detaliile dvs. au fost salvate. Multumesc',
                back: 'Înapoi la Acasă',
                fields: {
                    name: 'Numele complet',
                    email: 'Adresa de e-mail',
                    reference: 'Plata Ref.',
                    amount: 'Suma ($)',
                    name_on_card: 'Nume Pe Card',
                    submit: 'Trimiteți plata',
                },
                warning: {
                    currency: 'Notă: suma plății în {{actual}}, nu în {{default}}',
                },
                errors: {
                    generic: 'A apărut o eroare, încercați din nou sau contactați-ne',
                    stripe_generic: 'Eroare card de credit, reîmprospătați pagina și încercați din nou',
                    payment_fail: 'Plata nu a reușit, încercați din nou sau selectați altă metodă de plată',
                    payment_cancelled: 'Plata a fost anulată, încercați din nou sau selectați altă metodă de plată',
                    payment_error: 'Eroare la procesarea plății online, încercați din nou sau alegeți o altă metodă de plată',
                    payment_declined: 'Metoda dvs. de plată a fost refuzată',
                    card_declined: "Karta dvs. a fost respinsă și plata nu a putut fi procesată",
                    promo_max_uses_exceeded: "Acest cod promoțional a atins limita de utilizare și nu mai este disponibil.",
                },
            },
            dish: {
                add: 'Adaugă in coş',
                edit: 'Actualizați elementul',
                notes: 'Instructiuni speciale...',
                ingredients: {
                    title: 'Ingrediente',
                    uncheck_remove: 'Debifați pentru a elimina',
                },
                ingredients_title: 'Ingrediente',
                combo: {
                    choose_dish: 'Alegeți un articol',
                },
                option_sets: {
                    conditions: {
                        select_one: 'Selectați unul (obligatoriu)',
                        select_one_optional: 'Selectați unul (Opțional)',
                        select_between: 'Selectați între {{min}} - {{max}} (obligatoriu)',
                        select_at_least: 'Selectați cel puțin {{qty}} (obligatoriu)',
                        select_up_to: 'Selectați până la {{qty}} (Opțional)',
                        select_multiple_optional: 'Selectați mai multe (Opțional)',
                        select_multiple: 'Selectați mai multe (obligatoriu)',
                        free_amount: 'Prima {{qty}} Gratuită / {{selected}} Aleasă',
                    },
                    points: {
                        none_consumed: 'Puteți alege gratuit maximum {{maxFree}} opțiuni',
                        less_than_total_points: 'Puteți alege mai multe opțiuni gratuit',
                        greather_than_total_points: 'Puteți alege mai multe opțiuni pentru un cost suplimentar',
                    },
                },
                error: 'Vă rugăm să corectați toate opțiunile marcate cu roșu',
                added_to_cart: 'Articol adăugat în coș',
            },
            map: {
                zone_fee: 'Taxa de livrare',
                view_in_google: 'Vizualizați în Google Maps',
            },
            portal_go_back: {
                title: 'Înapoi la căutarea restaurantelor?',
                description: 'Orice articole din coșul dvs. se vor pierde',
                cancel: 'Anula',
                proceed: 'Întoarce-te',
            },
            order: {
                config: {
                    services: {
                        title: 'Alegeți un serviciu',
                        table_booking: 'Masa de carte',
                    },
                    address_custom: {
                        input_placeholder: 'Introdu adresa ta',
                    },
                    address: {
                        input_placeholder: 'Găsiți adresa dvs. de livrare',
                        extras_placeholder: 'Numărul unității, numele clădirii, instrucțiunile de livrare etc...',
                        search_placeholder: 'Căutați adresa dvs',
                        search_input_placeholder: 'Tastați pentru a căuta',
                        no_address_found: 'Nu s-au găsit adrese. Încercați să introduceți mai mult de 5 caractere',
                        not_found: 'Adresa de livrare nu a fost găsită sau validă, încercați din nou',
                        not_delivering: 'Momentan nu livrăm la această adresă',
                        not_in_range: 'Adresa dvs. nu se află în raza locației magazinului nostru',
                        not_in_zone: 'Adresa dvs. nu se află într-o zonă de livrare activă',
                        no_number: 'Adresa dvs. trebuie să aibă un număr de stradă',
                        location_permission: 'Permiteți acestui site să vă acceseze locația actuală?',
                        location_permission_warning: "Nu puteți accesa locația actuală. Vă rugăm să activați serviciul de locație pe dispozitivul dvs. și browserul web. Aici sunt câteva referințe:",
                        pick_location: 'Alegeți locația dvs',
                        pick_location_help_text: 'Trageți marcatorul pentru a alege locația de pe hartă.',
                        use_current_location: 'Utilizați locația curentă',
                        locate_on_map: 'Localizați pe hartă',
                    },
                    datetime: {
                        title: 'Când doriți comanda dvs',
                        due_now: 'Acum',
                        due_later: 'Mai târziu',
                        service_not_available: 'Ne pare rău, momentan nu acceptăm comenzi pentru {{service}}',
                        currently_closed: '{{service}} momentan închis, dar puteți comanda pentru mai târziu',
                        due_unavailable: 'Indisponibil',
                        due_closed: 'Închis',
                        select_date: 'Selectați Data',
                        select_time: 'Selectați Ora',
                        select_order_date: 'Selectați data comenzii dvs',
                        select_order_time: 'Selectați Ora comenzii dvs',
                        select_order_date_time: 'Selectați data/ora comenzii dvs',
                        select_booking_date: 'Selectați data rezervării dvs',
                        select_booking_time: 'Selectați ora rezervării dvs',
                        no_times_available: 'Nu există ore disponibile pentru a alege',
                        date_today: '(Astăzi)',
                        date_closed: '(Închis)',
                        date_bookings_paused: '(Rezervări suspendate)',
                        time_slot_closed: 'Închis',
                    },
                    number_of_people: {
                        placeholder: 'Numărul de persoane',
                    },
                    table: {
                        select: 'Selectați Tabel',
                        select_popup_title: 'Selectați tabelul dvs',
                        password: 'Parola tabelului',
                        password_warning: 'Introduceți parola tabelului pentru a continua',
                    },
                    warning: {
                        closed: 'Ne pare rău, momentan suntem închise/nu acceptăm nicio comandă',
                        not_available: 'Ne pare rău, momentan nu acceptăm nicio comandă',
                    },
                    eta: {
                        delivery: `Timpul de livrare estimat este de aproximativ {{minutesToCustomer}} minute`,
                        pickup: `Comanda va fi gata în aproximativ {{minutesToCustomer}} minute`,
                    },
                    start_button: 'Începe comanda',
                },
                history: {
                    invalid: 'Nu sunt eligibile pentru a comanda semula deoarece unele dintre articolele comandate au fost modificate sau nu mai sunt disponibile',
                },
                reorder: {
                    title: 'Recomandă rapidă',
                    description: 'Comandați cu ușurință articolele din comenzile dvs. anterioare',
                },
            },
            receipt: {
                errors: {
                    not_found: 'Comanda nu a fost găsită, reîmprospătați pagina și încercați din nou',
                    booking_not_found: 'Rezervarea nu există. Este posibil să fi fost ștearsă',
                    generic: 'A apărut o eroare, reîmprospătați pagina sau contactați-ne',
                },
                connection: {
                    connected: 'Actualizări în timp real',
                    connecting: 'Actualizări în timp real se conectează',
                    disconnected: 'Actualizări în timp real deconectate',
                },
            },
            warnings: {
                logout: {
                    pretitle: 'Avertizare',
                    title: 'Deconectare',
                    body: 'Deconectarea va elimina toate articolele care au fost adăugate în coș',
                    cancel: 'Anula',
                    proceed: 'Continuă',
                },
                order_restart: {
                    warning: 'Avertizare',
                    title: 'Modificați detaliile comenzii',
                    body: 'Modificarea detaliilor comenzii va elimina articolele din coș, deoarece anumite articole pot deveni indisponibile',
                    cancel: 'Anula',
                    proceed: 'Continuă',
                },
                order_expired: {
                    subtitle: 'Important',
                    title: 'Comanda a fost schimbată la scadență imediat',
                    description: 'Ora selectată pentru comanda dvs. nu este prea departe. Prin urmare, comanda dvs. a fost modificată pentru a fi imediat / cât mai curând posibil',
                    button: 'Bine',
                },
                order_expiring: {
                    subtitle: 'Important',
                    title: 'Termenul limită pentru comandă expiră în curând',
                    description: 'Comanda dvs. trebuie plasată înainte de {{time, timeFromTimestamp}}, altfel nu mai este valabilă',
                    button: 'Bine',
                },
                location_permission: {
                    cancel: 'Anula',
                    proceed: 'Continuă',
                },
            },
            card_payment_authentication: {
                title: 'Autentificare de plată',
                note: 'Vă rugăm să păstrați această fereastră deschisă până când finalizați procesul de autentificare de la banca dvs.',
            },
            maps: {
                cancel: 'Anula',
                use_location: 'Utilizați locația',
            },
            app_refresh: {
                refresh: 'Reîmprospăta',
                title: 'Magazin de reîmprospătare',
                description: 'Magazinul nostru a fost actualizat. Vă rugăm să reîmprospătați browserul pentru a accesa cea mai recentă versiune. După reîmprospătare, vă puteți deschide coșul pentru a continua procesul de verificare.',
            },
        },
        sections: {
            nav_top: {
                guest: 'Oaspete',
                login: 'Autentificare',
                login_signup: 'Autentificare / Înregistrare',
                logout: 'Deconectare',
            },
            menus: {
                info: {
                    no_menus: 'Momentan nu există meniuri disponibile',
                    restrictions: 'Restricții de meniu',
                    not_available: 'Meniul indisponibil',
                    unavailable: {
                        times: "Meniul este indisponibil, cerințele comenzii dvs. nu se încadrează sub",
                        services: "Meniul este indisponibil, cerințele comenzii dvs. nu se încadrează sub",
                        hours: 'Meniul indisponibil, orele de comandă nu se încadrează în orele disponibile din acest meniu',
                        pre_order: "Meniul este indisponibil, cerințele comenzii dvs. nu se încadrează sub",
                        age: 'Meniul indisponibil, trebuie să fiți autentificat cu un cont verificat de vârstă pentru a comanda din acest meniu',
                    },
                    services: {
                        title: 'Cerințe de comandă',
                        pickup: 'Pickupuri',
                        delivery: 'Livrări',
                        dine_in: 'Dine-Ins',
                    },
                    times: {
                        now: 'Fără precomenzi',
                        later: 'Doar comenzi anticipate',
                    },
                    hours: {
                        title: 'Ore disponibile',
                    },
                    preorder: {
                        title: 'Cerințe de precomandă',
                        days_in_advance: 'Trebuie să comandați cu {{days}} zile în avans',
                        cutoff_time: 'Ora limită pentru ultima zi la {{time, timeFromTime}}',
                    },
                    age_restricted: {
                        title: 'Limitat de vârstă',
                        approved: 'Contul dvs. este verificat și puteți comanda din acest meniu',
                        rejected: 'Necesită verificarea vârstei pentru a comanda. Creați un cont și încărcați-vă ID-ul',
                    },
                },
                search: {
                    title: 'Explorați elementele din meniu',
                    no_result: 'Nimic nu s-a întors. Încercați alt termen de căutare?',
                    placeholder: 'Ce căutați?',
                },
            },
            category: {
                restrictions: 'Restricții de categorie',
                not_available: 'Categoria Indisponibilă',
                unavailable: {
                    services: "Categoria este indisponibilă, cerințele comenzii dvs. nu se încadrează sub",
                    hours: "Categoria este indisponibilă, orele comenzii dvs. nu se încadrează în orele disponibile din această categorie",
                },
            },
            info: {
                location: {
                    title: 'Locaţie',
                    view_map: 'Vezi harta',
                    phone: 'Telefon',
                },
                hours: {
                    title: 'Orele de deschidere',
                    title_special: 'Program special de deschidere',
                },
                services: {
                    title: 'Servicii',
                    notes: 'Note',
                    delivery: {
                        ranges: 'Domenii de livrare',
                        zones: 'Zone de livrare',
                        view_zones: 'Vizualizați zonele pe hartă',
                        fee: 'Taxa de livrare',
                        fee_short: 'Taxă',
                        fee_varies: 'Variază, afișat în coș',
                        min_order: 'Comanda minima',
                        min_order_short: 'Com. min.',
                        no_min_order: 'Fără comandă minimă',
                        free_amount: 'Suma de livrare gratuită',
                    },
                },
            },
            contact: {
                title: 'Contactaţi-ne',
                name: 'Nume',
                email: 'E-mail',
                phone: 'Număr de telefon',
                message: 'Introdu mesajul tau...',
                send: 'Trimite mesaj',
                success: 'Mesajul dvs. a fost trimis cu succes',
                error: 'A apărut o eroare, încercați din nou sau mai târziu',
            },
            footer: {
                powered_by: 'Cu sprijinul',
                terms_and_conditions: 'Termeni și condiții',
                privacy: 'Politica de confidențialitate',
                cookie: 'Politica cookie',
            },
        },
        pages: {
            payment_completed: {
                title: 'Plata dvs. a fost procesată. Vă mulțumim pentru comandă!',
                subtitle: 'Informațiile despre comandă au fost trimise la adresa dvs. de e-mail.',
                back_to_menu: 'Înapoi la Meniu',
                close_tab: 'Închideți această filă',
            },
            payment_failed: {
                title: 'Din păcate, a apărut o eroare la procesarea plății.',
                subtitle: '',
                back_to_menu: 'Înapoi la Meniu',
                close_tab: 'Închideți această filă',
            },
        },
    },
    // MODELS
    booking: {
        receipt: {
            title: 'Chitanța de rezervare',
            details: {
                datetime: 'Rezervare pentru',
                number_of_people: 'Nr. de oameni',
                placed: 'Plasat',
                updated: 'Ultima actualizare',
                notes: 'Note',
                name: 'Nume',
                email: 'E-mail',
                phone: 'Telefon',
                store_address: 'Adresa magazinului',
            },
            status_update: {
                title: 'Rezervare {{number}} Actualizată',
                body: 'Starea rezervării dvs. a fost actualizată la {{status}}',
            },
            email_common: {
                name: 'Nume: {{name}}',
                phone: 'Telefon: {{number}}',
                number_of_people: 'Număr de persoane: {{number}}',
                date: 'Data: {{date}}',
                time: 'Ora: {{time}}',
                location: 'Locația magazinului: {{name}}',
                notes: 'Note: {{name}}',
            },
            email_new_booking_restaurant: {
                subject: 'Rezervare de masă nouă {{number}} Până la {{name}}',
                powered_by: 'Produs de {{name}}',
                overview: 'Cerere de rezervare pentru masă nouă',
                title: 'Rezervare nouă pentru {{name}}',
                subtitle: 'Numărul rezervării {{number}}',
                description_confirmed: 'Rezervarea a fost automat confirmată. Puteți să o anulați prin intermediul tabloului de bord administrativ și clientul dvs. va fi notificat prin e-mail',
                description_unconfirmed: 'Vă rugăm să confirmați sau să anulați rezervarea prin intermediul tabloului de bord administrativ',
                url_pre_text: 'Vizualizați și actualizați la',
            },
            email_new_booking_customer: {
                subject: 'Cerere de rezervare la masă',
                powered_by: 'Produs de {{name}}',
                overview: 'Cerere de rezervare pentru masă nouă',
                title: 'Vă mulțumim pentru rezervare',
                subtitle: 'Numărul rezervării {{number}}',
                description: '<b>Veți primi un alt e-mail când rezervarea dvs. va fi confirmată sau respinsă.</b><br>Vă rugăm să contactați-ne pentru a face orice modificări la rezervarea dvs. Detaliile rezervării dvs. sunt următoarele:',
                url_pre_text: 'Puteți vizualiza chitanța de rezervare în timp real la',
            },
            email_update_booking_customer: {
                subject_confirmed: 'Rezervarea mesei a fost confirmată',
                subject_unconfirmed: 'Rezervarea la masă a fost anulată',
                powered_by: 'Produs de {{name}}',
                overview: 'Cerere de rezervare la masă',
                title_confirmed: 'Rezervare confirmată',
                title_unconfirmed: 'Rezervare anulată',
                subtitle: 'Numărul rezervării {{number}}',
                description_confirmed: 'Ne bucurăm să vă vedem. Vă rugăm să contactați-ne pentru a solicita orice modificări la rezervarea dvs.',
                description_unconfirmed: 'Ne pare rău să vă informăm că cererea dvs. de rezervare nu a putut fi acceptată. Ne cerem scuze pentru orice inconveniență cauzată. Vă rugăm să contactați-ne dacă aveți orice întrebări',
                url_pre_text: 'Puteți vizualiza chitanța de rezervare în timp real la',
            },
            email_status_update_customer: {
                subject: 'Rezervare #{{number}} – {{subjectLabel}}',
                body: 'Rezervarea dvs. #{{number}} la {{store}} este acum {{status}}.',
            },
            errors: {},
            status_warning: 'Actualizați starea acestei rezervări în tabloul de bord administrativ din pagina de rezervări',
        },
    },
    email_delayed_order: {
        subject: 'Comandă #{{number}} – {{subjectLabel}}',
        header: 'Oră de preparare actualizată',
        title: 'Oră de preparare actualizată',
        order_number: 'Număr comandă: {{number}}',
        description: 'Comanda dvs. va fi gata la {{time}}.',
        order_time_updated_to: 'Ora comenzii dvs. a fost actualizată.',
        powered_by: 'Produs de {{name}}',
        button_text: 'Urmăriți comanda',
        subject_label: 'Oră de preparare actualizată',
        subject_label_delivery: 'Oră de livrare actualizată',
        body_ready: 'Comanda dvs. va fi gata la {{time}}.',
        body_delivery: 'Comanda dvs. va fi livrată la {{time}}.',
    },
    order: {
        receipt: {
            est_ready_time: 'EST. Timp de pregătire',
            est_driver_pickup_time: 'EST. Ora de preluare a șoferului',
            est_delivery_time: 'EST. Timpul de livrare',
            tab_details: 'Detalii',
            tab_dishes: 'Articole',
            future_order: 'Ordine viitoare',
            reprint: 'RETIPĂRIRE',
            details: {
                order_no: 'Comanda nr.',
                status: 'Stare',
                placed: 'Plasat',
                due: 'Datorită',
                due_asap: 'Acum / cât mai curând posibil',
                last_updated: 'Ultima actualizare',
                total: 'Total',
                type: 'Tip',
                origin: 'Origine',
                table: 'Masă',
                number_of_people: 'Numărul de persoane',
                payment_method: 'Modalitate de plată',
                payment_status: 'Starea plății',
                payment_currency: 'Moneda de plată',
                notes: 'Note',
                name: 'Nume',
                email: 'E-mail',
                phone: 'Telefon',
                distance: 'Distanţă',
                driving_time: 'Timp de condus',
                delivery_zone: 'Zonă',
                delivery_address: 'Adresa de livrare',
                delivery_provider: 'Furnizor de livrare',
                delivery_tracking: 'Urmărirea livrării',
                delivery_return_tracking: 'Întoarcere pe pistă',
                delivery_tracking_link: 'Urmăriți comanda',
                tookan_status: 'Statutul Tookan',
                tookan_status_failed_book: 'Nu s-a putut rezerva livrarea',
                tookan_status_failed_update: 'Nu s-a putut actualiza rezervarea',
                tookan_status_success: 'Rezervat pentru livrare',
                store_address: 'Adresa magazinului',
                destination: 'Destinaţie',
                estimated_arrival_time: 'Ora estimată de sosire',
                delivery_status: 'Stare',
                delivery_track_your_order: 'Urmăriți-vă comanda',
                delivery_text: 'Livrare',
                arrival_date: 'Data sosirii',
            },
            dishes: {
                headings: {
                    quantity: 'Cant',
                    item: 'Articol',
                    price: 'Preţ',
                },
                notes: 'Note',
                remove_ingredients: 'Scoateți ingredientele',
            },
            status_update: {
                title: 'Comanda {{number}} a fost actualizată',
                body: 'Starea comenzii dvs. a fost actualizată la {{status}}',
            },
            wait_time_update: {
                title: 'Comanda {{number}} a fost actualizată',
                body: 'Data scadentă a comenzii dvs. a fost actualizată',
            },
            delivery_update: {
                title: 'Comanda {{number}} a fost actualizată',
                body: 'Comanda dvs. a fost rezervată pentru livrare. Vedeți linkul de urmărire în timp real',
            },
            payment_status_update: {
                title: 'Comanda {{number}} a fost actualizată',
                body: 'Starea plății comenzii dvs. a fost actualizată.',
            },
            email_new_order_restaurant: {
                subject: 'Comanda nouă ({{number}}) - {{name}}',
                powered_by: 'Produs de {{name}}',
                overview: 'Notificare de comandă nouă',
                title: 'Comandă nouă plasată la {{name}}',
                subtitle: 'Numărul comenzii {{number}}',
                description: 'Vedeți detalii și actualizări prin tabloul de bord administrativ',
                button_text: 'Urmăriți comanda',
                track_delivery_button_text: 'Urmăriți livrarea',
            },
            email_new_order_customer: {
                subject: 'Chitanța de comandă ({{number}})',
                powered_by: 'Produs de {{name}}',
                overview: 'Notificare de comandă nouă',
                title: 'Comandă nouă plasată la {{name}}',
                subtitle: 'Numărul comenzii {{number}}',
                description: 'Vizualizați detalii și actualizări prin chitanța dvs. online în timp real',
                button_text: 'Urmăriți comanda',
                track_delivery_button_text: 'Urmăriți livrarea',
            },
            email_order_completed_by_customer: {
                subject: 'Comanda ({{number}}) finalizată de client',
                powered_by: 'Produs de {{name}}',
                overview: 'Notificare comanda finalizată',
                title: 'Comanda finalizată la {{name}}',
                subtitle: 'Numărul comenzii {{number}}',
                description: 'Vizualizați detaliile și actualizările comenzii dvs. prin tabloul de bord sau folosind chitanța la',
            },
        },
        totals: {
            tax: '{{name}} ({{percent}}%)',
            tax_in_prices: '{{name}} ({{percent}}%) inc. in pret',
            fee: '{{name}} ({{value, currency}} + {{percent}}%)',
            fee_percent: '{{name}} ({{percent}}%)',
            fee_fixed: '{{name}}',
            delivery_fee: 'Taxa de livrare',
            delivery_fee_offset: 'Reducere la taxa de livrare',
            delivery_fee_total: 'Taxa de livrare totală',
            promo: 'Reducere: {{name}} ({{value, currency}} + {{percent}}% reducere)',
            promo_percent: 'Reducere: {{name}} ({{percent}}%)',
            promo_fixed: 'Reducere: {{name}}',
            promo_none: 'Reducere: {{name}}',
            cart: 'Coș',
            tip: 'Sfat de comandă',
            total: 'Totalul',
        },
        status: {
            unconfirmed: 'Neconfirmat',
            awaiting_payment: 'În așteptarea plății',
            confirmed: 'Confirmat',
            ready: 'Gata',
            on_route: 'Pe traseu',
            complete: 'Complet',
            cancelled: 'Anulat',
            seated: 'Așezați',
        },
        searching: {
            lalamove_search_placeholder: 'Căutați comanda după ID-ul de livrare Lalamove',
        },
    },
    restaurant: {
        menus: {
            option_set: {
                option: {
                    unavailable: 'Indisponibil',
                },
            },
            dish: {
                no_stock: 'Epuizat',
                not_available: 'Nu este disponibil',
            },
        },
    },
    admin: {
        registration: {
            register_confirmation_code_subject: 'Cod de confirmare prin e-mail',
            register_confirmation_code_email: 'Codul dvs. de confirmare prin e-mail este {{confirmation_code}} (Expiră în 24 de ore)',
            register_confirmation_code_email_onbehalf: 'Codul dvs. de confirmare prin e-mail este {{confirmation_code}} (Expiră în 24 de ore). Acesta este pentru adresa de e-mail, {{email}}.',
        },
    },
};
//# sourceMappingURL=ro.js.map